<template>
    <div class="container">
        <b-breadcrumb :items="items" variant="primary"></b-breadcrumb>


        <h1>História porúch svietidla {{ point.name }}
            <router-link
                :to="{ name: 'dashboard', params: {point: point.name}}"
                class="btn btn-outline-primary btn-sm float-right"
            >
                <font-awesome-icon :icon="['fas', 'map-marked-alt']" />
                Zobraziť bod na mape
            </router-link>
        </h1>
        <p v-if="!loading && !point.defects.length">Pre tento bod neboli zatiaľ nahlásené žiadne poruchy</p>
        <ul class="timeline" v-if="!loading && point.defects.length">
            <li class="event" :data-date="defect.created_at | moment('DD.MM.YYYY HH:mm:ss')"
                v-for="defect in point.defects" :key="defect.id">

                <div><b>Nahlásené poruchy:</b> {{ defect.defects }}</div>
                <div><b>Popis poruchy:</b> {{ defect.note }}</div>
                <div><b>Riešenia:</b> {{ defect.solutions }}</div>
                <div><b>Popis odstránenia závady:</b> {{ defect.solution_note }}</div>
                <div><b>Typ:</b> {{ defect.defect_type ? defect.defect_type.name : "" }}</div>
                <div><b>Zodpovedný:</b> {{ defect.user ? defect.user.name : "" }}</div>
                <div><b>Dátum prebratia:</b> {{ defect.repair_started | moment("DD.MM.YYYY HH:mm:ss") }}</div>
                <div><b>Dátum vyriešenia:</b> {{ defect.repair_finished | moment("DD.MM.YYYY HH:mm:ss") }}</div>
                <div><b>Doba riešenia:</b> {{ defect.solution_length }}</div>
            </li>
            <!--            https://codepen.io/alanhouser/pen/aErrQJ-->
        </ul>
    </div>
</template>

<script>
import api from "@/store/api"

export default {
    name: "DefectsHistoryDetail",
    data() {
        return {
            point: [],
            loading: true,
            items: [
                {
                    text: 'Mapa',
                    to: { name: 'dashboard'}
                },
                {
                    text: 'História porúch',
                    to: { name: 'defectsHistory'}
                },
                {
                    text: 'Detail',
                    active: true
                }
            ]
        }
    },
    mounted() {
        this.loading = true
        api.get(`/reported/history/${this.$route.params.id}`)
            .then(response => {
                this.point = response.data
                this.loading = false
            })
            .catch(error => {
                alert(error)
                this.loading = false
            })
    },
}
</script>

<style scoped lang="scss">
$breadcrumb-divider: none;

$background: #252827;
$color-primary: #004ffc;
$color-light: white;
$color-dim: #6c6d6d;
$spacing: 50px;
$radius: 4px;

$date: 120px;
$dotborder: 4px;
$dot: 11px;
$line: 4px;

$font-title: 'Saira', sans-serif;
$font-text: 'Chivo', sans-serif;

.breadcrumb {
    background: none;
    padding-left: 0;
    padding-right: 0;
}

.timeline {
    border-left: 4px solid rgba(0, 0, 0, 0.12);
    border-bottom-right-radius: $radius;
    border-top-right-radius: $radius;
    background: fade($color-light, 3%);
    color: fade(white, 80%);
    font-family: $font-text;
    margin: $spacing auto;
    letter-spacing: 0.5px;
    position: relative;
    line-height: 1.4em;
    font-size: 1.03em;
    padding: $spacing;
    list-style: none;
    text-align: left;
    font-weight: 100;
    max-width: 70%;

    h1 {
        font-family: $font-title;
        letter-spacing: 1.5px;
        font-weight: 100;
        font-size: 1.4em;
    }

    h2, h3 {
        font-family: $font-title;
        letter-spacing: 1.5px;
        font-weight: 400;
        font-size: 1.4em;
    }

    .event {
        border-bottom: 1px dashed fade($color-light, 10%);
        padding-bottom: ($spacing * 0.5);
        margin-bottom: $spacing;
        position: relative;

        &:last-of-type {
            padding-bottom: 0;
            margin-bottom: 0;
            border: none;
        }

        &:before, &:after {
            position: absolute;
            display: block;
            top: 0;
        }

        &:before {
            left: ((($date * 0.6) + $spacing + $line + $dot + ($dotborder * 2)) * 1.5) * -1;
            color: fade($color-light, 40%);
            content: attr(data-date);
            text-align: right;
            font-weight: 100;
            font-size: 0.9em;
            min-width: $date;
            font-family: $font-title;
        }

        &:after {
            box-shadow: 0 0 0 $dotborder fade($color-primary, 100%);
            left: ($spacing + $line + ($dot * 0.35)) * -1;
            background: lighten($background, 5%);
            border-radius: 50%;
            height: $dot;
            width: $dot;
            content: "";
            top: 5px;
        }
    }
}
</style>
